import React from 'react'

class FullScreenSlider extends React.Component {

  render() {
    const { bg, sliderLogo } = this.props;
    return (
      <section id="slider" className="no-padding position-relative">
        <div id="mainSlider" className="owl-carousel owl-theme dark-pagination square-pagination main-slider" style={{opacity: 1, display: 'block'}}>
          <div className="mainSlider item owl-bg-img" style={{backgroundImage: `url('${bg}')`}}>
            <img className="first_slide_logo" src={sliderLogo} />
          </div>
        </div>
      </section>
    )
  }
}

export default FullScreenSlider


// WEBPACK FOOTER //
// ./src/components/FullScreenSlider/index.js